module.exports = __webpack_public_path__ + "static/img/upgrade-success.c9cba51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/upgraded/images/upgrade-success.svg
// module id = Tacz
// module chunks = 26